/**
 * Returns the total assignment price including customizations
 *
 * @param assignment
 * @returns
 */
export const getTotalAssignmentPrice = (assignment) => {
    var _a, _b;
    const totalReplacementPrice = (_a = assignment.SelectedIngredientOptions) === null || _a === void 0 ? void 0 : _a.reduce((total, option) => {
        return total + getSelectedOptionsTotal(option.selectedOptions);
    }, 0);
    const basePrice = (_b = assignment === null || assignment === void 0 ? void 0 : assignment.RecipeAssignmentPrice) !== null && _b !== void 0 ? _b : 0;
    const quantity = assignment.Quantity;
    return (totalReplacementPrice + basePrice) * quantity;
};
/**
 * Calculates the total replacement price of selected ingredient options.
 *
 * @param {SelectedIngredientOptionData[]} options - The array of selected ingredient options.
 * @returns {number} The total replacement price of the selected options.
 */
export const getSelectedOptionsTotal = (options) => {
    return options === null || options === void 0 ? void 0 : options.reduce((subTotal, ing) => {
        var _a;
        return subTotal + ((_a = ing === null || ing === void 0 ? void 0 : ing.replacementPrice) !== null && _a !== void 0 ? _a : 0);
    }, 0);
};
